import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useTranslation, Trans } from 'react-i18next';
import LanguageSwitcher from '../../Component/LanguageSwitcher';

const PublicPF = () => {
    const { t } = useTranslation();

    document.title = t('documentTitle');
    document.querySelector('meta[name="description"]').setAttribute('content', t('metaDescription'));

    return (
        <div>
            <header className="d-flex justify-content-end align-items-center p-3 border-bottom">
                <LanguageSwitcher />
            </header>

            <div className="webview">
                <Container>
                    <Row>
                        <Col xs={12}>
                            <Trans i18nKey="intro1"
                                components={[
                                    <strong key="0" />,
                                    <strong key="1" />,
                                    <a
                                        key="2"
                                        title="Public Provident Fund account"
                                        href="https://www.goodreturns.in/classroom/2017/05/opening-ppf-account-post-office-you-need-know-572820.html"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    />
                                ]}
                            />
                            <br />
                            <br />
                            <Trans i18nKey="intro2" />

                            <h2><Trans i18nKey="aboutHeader" /></h2>
                            <Trans i18nKey="about1" />
                            <br />
                            <br />
                            <Trans i18nKey="about2" />
                            <br />
                            <br />
                            <Trans i18nKey="about3" />
                            <br />
                            <br />
                            <Trans i18nKey="about4" />

                            <h2><Trans i18nKey="whyOpenHeader" /></h2>
                            <Trans i18nKey="whyOpen1" />

                            <h2><Trans i18nKey="eligibilityHeader" /></h2>
                            <Trans i18nKey="eligibility1" />
                            <br />
                            <br />
                            <Trans i18nKey="eligibility2" />

                            <h2><Trans i18nKey="nominationHeader" /></h2>
                            <Trans i18nKey="nomination1" />

                            <h2><Trans i18nKey="featuresHeader" /></h2>
                            <Trans i18nKey="features1" />
                            <h3><Trans i18nKey="minInvestmentHeader" /></h3>
                            <Trans i18nKey="minInvestment1" />
                            <h3><Trans i18nKey="tenureHeader" /></h3>
                            <Trans i18nKey="tenure1" />
                            <h3><Trans i18nKey="safetyHeader" /></h3>
                            <Trans i18nKey="safety1" />
                            <h3><Trans i18nKey="taxBenefitsHeader" /></h3>
                            <Trans i18nKey="taxBenefits1"
                                components={[
                                    <a
                                        key="0"
                                        title="Section 80C of the Income Tax Act of 1961"
                                        href="https://www.goodreturns.in/section-80c-of-income-tax-act-s1.html"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    />
                                ]}
                            />
                            <br />
                            <br />
                            <Trans i18nKey="taxBenefits2" />
                            <h3><Trans i18nKey="loanAgainstHeader" /></h3>
                            <Trans i18nKey="loanAgainst1" />
                            <br />
                            <br />
                            <Trans i18nKey="loanAgainst2" />
                            <h3><Trans i18nKey="interestRateHeader" /></h3>
                            <Trans i18nKey="interestRate1" />

                            <h2><Trans i18nKey="openAccountHeader" /></h2>
                            <Trans i18nKey="openAccount1" />
                            <br />
                            <br />
                            <Trans i18nKey="openAccount2" />
                            <br />
                            <br />
                            <Trans i18nKey="docsHeader" />
                            <ul>
                                <li>
                                    <Trans
                                        i18nKey="docsPAN"
                                        components={[
                                            <a
                                                key="0"
                                                title="PAN Card"
                                                href="https://www.goodreturns.in/pan-card.html"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            />
                                        ]}
                                    />
                                </li>

                                <li><Trans i18nKey="docsAddress" /></li>
                                <li><Trans i18nKey="docsKYC" /></li>
                                <li><Trans i18nKey="docsNominee" /></li>
                                <li><Trans i18nKey="docsPhoto" /></li>
                            </ul>

                            <h2><Trans i18nKey="tenureHeader2" /></h2>
                            <Trans i18nKey="tenure2" />

                            <h2><Trans i18nKey="withdrawalHeader" /></h2>
                            <Trans i18nKey="withdrawal1" />
                            <ul>
                                <li><Trans i18nKey="withdrawalList1" /></li>
                                <li><Trans i18nKey="withdrawalList2" /></li>
                                <li><Trans i18nKey="withdrawalList3" /></li>
                                <li><Trans i18nKey="withdrawalList4" /></li>
                            </ul>
                            <Trans i18nKey="withdrawalNote" />

                            <h2><Trans i18nKey="withdrawalsHeader" /></h2>
                            <Trans i18nKey="withdrawals1" />

                            <h2><Trans i18nKey="defaultingHeader" /></h2>
                            <Trans i18nKey="defaulting1" />
                            <br /><br />
                            <Trans i18nKey="defaulting2" />
                            <br />
                            <br />
                            <Trans i18nKey="defaulting3" />

                            <h2><Trans i18nKey="prematureClosureHeader" /></h2>
                            <Trans i18nKey="prematureClosure1" />
                            <br />
                            <br />
                            <Trans i18nKey="prematureClosure2" />
                            <br />
                            <br />
                            <Trans i18nKey="prematureClosure3" />

                            <h2><Trans i18nKey="taxBenefitsHeader2" /></h2>
                            <Trans i18nKey="taxBenefits3" />
                            <br />
                            <br />
                            <Trans i18nKey="taxBenefits4" />

                            <h2><Trans i18nKey="faqHeader" /></h2>
                            <h4><Trans i18nKey="faq1Q" /></h4>
                            <Trans i18nKey="faq1A" />
                            <h4><Trans i18nKey="faq2Q" /></h4>
                            <Trans i18nKey="faq2A" />
                            <ul>
                                <li><Trans i18nKey="faq2List1" /></li>
                                <li><Trans i18nKey="faq2List2" /></li>
                                <li><Trans i18nKey="faq2List3" /></li>
                                <li><Trans i18nKey="faq2List4" /></li>
                                <li><Trans i18nKey="faq2List5" /></li>
                                <li><Trans i18nKey="faq2List6" /></li>
                                <li><Trans i18nKey="faq2List7" /></li>
                                <li><Trans i18nKey="faq2List8" /></li>
                                <li><Trans i18nKey="faq2List9" /></li>
                                <li><Trans i18nKey="faq2List10" /></li>
                                <li><Trans i18nKey="faq2List11" /></li>
                                <li><Trans i18nKey="faq2List12" /></li>
                                <li><Trans i18nKey="faq2List13" /></li>
                            </ul>
                            <h4><Trans i18nKey="faq3Q" /></h4>
                            <Trans i18nKey="faq3A" />
                            <h4><Trans i18nKey="faq4Q" /></h4>
                            <Trans i18nKey="faq4A" />
                            <h4><Trans i18nKey="faq5Q" /></h4>
                            <Trans i18nKey="faq5A" />
                            <h4><Trans i18nKey="faq6Q" /></h4>
                            <Trans i18nKey="faq6A" />
                            <h4><Trans i18nKey="faq7Q" /></h4>
                            <Trans i18nKey="faq7A" />
                            <h4><Trans i18nKey="faq8Q" /></h4>
                            <Trans i18nKey="faq8A" />
                            <h4><Trans i18nKey="faq9Q" /></h4>
                            <Trans i18nKey="faq9A" />
                            <h4><Trans i18nKey="faq10Q" /></h4>
                            <Trans i18nKey="faq10A" />
                            <h4><Trans i18nKey="faq11Q" /></h4>
                            <Trans i18nKey="faq11A" />
                            <h4><Trans i18nKey="faq12Q" /></h4>
                            <Trans i18nKey="faq12A" />
                            <h4><Trans i18nKey="faq13Q" /></h4>
                            <Trans i18nKey="faq13A" />
                            <h4><Trans i18nKey="faq14Q" /></h4>
                            <Trans i18nKey="faq14A" />
                            <h4><Trans i18nKey="faq15Q" /></h4>
                            <Trans i18nKey="faq15A" />
                            <h4><Trans i18nKey="faq16Q" /></h4>
                            <Trans i18nKey="faq16A" />
                            <h4><Trans i18nKey="faq17Q" /></h4>
                            <Trans i18nKey="faq17A" />
                            <h4><Trans i18nKey="faq18Q" /></h4>
                            <Trans i18nKey="faq18A" />
                            <h4><Trans i18nKey="faq19Q" /></h4>
                            <Trans i18nKey="faq19A" />
                            <h4><Trans i18nKey="faq20Q" /></h4>
                            <Trans i18nKey="faq20A" />
                            <h4><Trans i18nKey="faq21Q" /></h4>
                            <Trans i18nKey="faq21A" />
                            <h4><Trans i18nKey="faq22Q" /></h4>
                            <Trans i18nKey="faq22A" />
                            <h4><Trans i18nKey="faq23Q" /></h4>
                            <Trans i18nKey="faq23A" />
                            <h4><Trans i18nKey="faq24Q" /></h4>
                            <Trans i18nKey="faq24A" />
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    );
}

export default PublicPF;